<div style="display: flex">
    <span matSnackBarLabel style="color: red"> ERROR! </span>
    <span matSnackBarActions>
        <button
            mat-button
            matSnackBarAction
            (click)="snackBarRef.dismissWithAction()"
        >
            Close
        </button>
    </span>
</div>
@for (error of errors; track error) {
<mat-divider style="background-color: white"></mat-divider>
<div class="errorContainer">
    @if (error.message) {
    <div class="error">
        <span matSnackBarLabel>Message:</span>
        @if(error?.extensions?.userMessage){
        <span matSnackBarLabel class="errorText"
            >{{error?.extensions?.userMessage}}
        </span>
        } @else{
        <span matSnackBarLabel class="errorText">{{error.message}} </span>
        }
    </div>
    }
    <div class="error">
        <span matSnackBarLabel>Correlation Id:</span>
        <span matSnackBarLabel class="errorText"
            >{{error.extensions?.correlationId}}
        </span>
    </div>
</div>
}
